import { render, staticRenderFns } from "./datasource-other-collect-method-form.vue?vue&type=template&id=ee947d74"
import script from "./datasource-other-collect-method-form.vue?vue&type=script&lang=js"
export * from "./datasource-other-collect-method-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports